import { Extent, getCenter } from 'ol/extent';
import { fromExtent } from 'ol/geom/Polygon';
import { Map } from 'ol';
import { Coordinate } from 'ol/coordinate';

export function scaleExtent(extent: Extent, x: number, y: number) {
    const poly = fromExtent(extent);
    poly.scale(x, y);
    return poly.getExtent();
}

export class Geometry {
    center: Coordinate;
    resolution: number;

    constructor(center: Coordinate, resolution: number) {
        this.center = center;
        this.resolution = resolution;
    }

    static fromExtent(extent: number[], map: Map) {
        return new Geometry(getCenter(extent), map.getView().getResolutionForExtent(extent, map.getSize()));
    }
}